/**
 * plugin.js
 *
 * Copyright 2011, eZdia
 * Released under LGPL License.
 *
 * License: http://www.ezdia.com
 * Contributing: http://www.tinymce.com/contributing
 */

/*global tinymce:true */

tinymce.PluginManager.add('ezdia', function(ed, url) {
    var t = this;
    var tdom = tinymce.DOM;
    var t$ = tinymce.dom.DomQuery;
    var baseUrl = url;
    var ltTimer;
    /**
        @param charcount - Specifies the character count needed for the field.
        @param wordcount - Specifies the character count needed for the field.
        @param wordcountActive - Set flag for Word count is active.
        @param wordsum - Specifies the total Word Sum count needed for the field.
        @param readonly - Specifies editor mode.
        @param keywords - Specifies the keywords count needed for the field.
        @param localStorage - Specifies the localStorage active for field.
        @param badContent - Specifies the badContent remove from editor.
        @param upload_file - Specifies the upload file in side editor.
        @param copyPasteContent - Specifies field have copy paste button.
        @param templates - Specifies custome template for field.
    **/
    t.mswordContent_message = 'The html content has some additional xml data from MS Word. You might want to check the <a href="javascript:;" onclick="openHtmlPastePanel(\'' + ed.id + '\')"> html source </a>and remove the unwanted html content.';
    t.defaultContent = document.getElementById(ed.id).defaultValue;
    t.charcount = ed.getParam('charcount', {});

    t.wordcount = ed.getParam('wordcount', {});
    t.wordcountActive = true;

    t.wordsum = ed.getParam('wordsum', false);

    t.isIce = ed.getParam('ice') ? true : false;
    t.readonly = ed.getParam('readonly', false);

    t.keywords = ed.getParam('keyword_density', null);
    t.localStorage = ed.getParam('local_storage', false);
    t.badContent = ed.getParam('badcontent', false);
    t.upload_file = ed.getParam('upload_file', false);
    t.copyPasteContent = ed.getParam('copypaste_var');
    t.templates = ed.getParam('ezdia_template');
    t.toggle = ed.getParam('toggle', false);
    t.inline = ed.getParam('inline', false);
    t.field_name = ed.getParam('field_name', null);
    t.languagetool = ed.getParam('languagetool', {
        enable: true
    });

    t.comments = ed.getParam('comments', false);
    t.commentCls = "ed-comments";
    t.commentClsSelect = "." + t.commentCls;
    t.addCommentButton = function () { };
    t.removeCommentButton = function () { };
    t.removeAllCommentsButton = function () { };

    ed.on('init', function(e) {
        var ezdia_common_css = baseUrl +'/css/ezdia_tinymce_common.css';
        
        if (!t.inline) {
            var ifr = tinymce.DOM.get(ed.id + '_ifr');
            var bootstrap_css = baseUrl + '/css/bootstrap.min.css';
            var ezdia_css = baseUrl +'/css/ezdia.css';
            
            ed.dom.loadCSS(bootstrap_css);
            ed.dom.loadCSS(ezdia_css);
            ed.settings.plugin_preview_width = $(ifr).width();
            ed.settings.plugin_preview_height = window.innerHeight - 80;
            
            if (!ed.settings.content_css) {
                Array.prototype.push.apply(ed.contentCSS, [bootstrap_css, ezdia_css, ezdia_common_css]);
            } else {
                Array.prototype.push.apply(ed.contentCSS, [ezdia_css, ezdia_common_css]);
            }
        }
        
        ed.dom.loadCSS(ezdia_common_css);
        
        var tx = ed.getContent();
        var keyCode = t._checkKeys(e);

        if (tx && !t.inline) {
            t._updateKeywordsCount();
            t._updateCount(keyCode);
        }
        
        $(this.getBody()).on('click', t.commentClsSelect, function(){
            t.editor.htmlEditor('comment', 'list', this.id);
        });
        
        if (!t.readonly && (t.languagetool.enable || t.keywords)) {
            ed.on('SaveContent', function() {
                t.editor.htmlEditor('clean');
            });       
        }

    });

    ed.on('postRender', function() {
        //console.log(t)
        //ed.dom.loadCSS( url + '/css/ezdia.css');
        /*Remove title from editor frame*/
        var ifr = tinymce.DOM.get(ed.id + '_ifr');
        ed.dom.setAttrib(ifr, 'title', '');
        
        t.editor = $('#' + ed.id);

        var ezdiaObj = {
            inline: t.inline,
            readonly: t.readonly,
            defaultContent: t.defaultContent,
            wordsum: t.wordsum,
            keywords: t.keywords,
            lt: t.languagetool.enable,
            field_name: t.field_name || ed.id,
            isIce: t.isIce,
            mswordMessage: t.mswordContent_message
        };

        if (!t.readonly) {
            var row = ed.theme.panel && ed.theme.panel.find('#statusbar')[0];

            $.extend(ezdiaObj, {
                charcount: t.charcount,
                wordcount: t.wordcount,
                badContent: t.badContent,
                countRow: row ? t$('#'+row._id + '-body') : null,
                toggle: t.toggle
            });

            /*Enable Local Storage*/
            if (t.localStorage) {
                $('#' + t.localStorage).localStorage('editor', ed);
            }
        }
        t.editor.htmlEditor(ezdiaObj);

        ed.on('blur', function() {
            t.editor.trigger('blur');
        });
    });

    ed.on('paste', function() {
        t.editor.htmlEditor('msWordContent');
    });
    
    if (!t.readonly && t.languagetool.enable && t.languagetool.auto) {
        ed.on('keyup paste undo redo', function() {
            clearTimeout(ltTimer);

            var content = ed.getContent();
            ed.settings.lt_isdirty = true;

            if (content) {
                ltTimer = setTimeout(function() {
                    t._languagetool();
                }, 2000);
            }
        });
    }    

    if (!t.readonly && (!t.wordcount.disable || !t.charcount.disable)) {

        ed.on('click keyup paste undo redo', function(e) {
            ed.keyCode = e.keyCode;
            
            setTimeout(function() {
                t._updateCounts(e);
            }, 0);
        });
        
        ed.on('NodeChange', function() {
            var tx = ed.selection.getContent();

            if(tx) {
                t.selectedCount = true;
                t.editor.htmlEditor('updateSelectedCount', t.selectedCount);
            } else if(t.selectedCount) {
                t.selectedCount = false;
                t.editor.htmlEditor('updateSelectedCount', t.selectedCount);
            }
        });        
    }

    t._updateCount = function(keyCode, eventType){
        var t = this;
        if (!t.readonly) {
            if (!t.wordcount.disable && (keyCode || eventType == 'click' || eventType == 'paste' || t.wordcountActive)) {
                setTimeout(function() {
                    t.editor.htmlEditor('updateWordCount');
                }, 0);
            }
            if (!t.charcount.disable) {
                t.editor.htmlEditor('updateCharCount');
            }
        }
    };

    t._updateKeywordsCount = function(){
        var t = this;
        if (t.keywords) {
            t.editor.htmlEditor('updateKeywordsCount');
        }
    };

    t._updateWordsum = function(){
        var t = this;

        if (t.wordsum) {
             t.editor.htmlEditor('updateWordsum');
        }

    };

    t._msWordContent = function(){
        this.editor.htmlEditor('msWordContent');
    };

    t._checkKeys = function(e){
        var code = e.keyCode;
        return code == 13 || code == 8 || code == 46 || code == 32 || (e.ctrlKey && (code == 86 || code == 88));
    };

    t._updateCounts = function(e){
        var keyCode = e ? t._checkKeys(e) : 32;

        t._updateCount(keyCode, e.type);

        if (keyCode || t.wordcountActive) {
            t.wordcountActive = keyCode;
            t._updateKeywordsCount();
            t._updateWordsum();
        }
    };
    
    t._languagetool = function(){
        ed.settings.lt_isdirty = false;
        t.editor.htmlEditor('languagetool');
    };    

    t.getCopyPasteBtn = function() {
        var len = t.copyPasteContent.length;
        var obj = t.copyPasteContent[0];
        var btnObj = {
            name: 'copypaste',
            text: obj.label,
            icon: false,
            onclick: function() {
                copy(obj.fromfield, ed.id);
            }
        };

        if (len != 1) {
            btnObj.type = 'splitbutton';
            btnObj.menu = [];
            t$.each(t.copyPasteContent, function(index, obj){
                if (index == 0) {
                    return true;
                }
                btnObj.menu.push({
                    text: obj.label,
                    onclick: function(){
                        copy(obj.fromfield, ed.id);
                    }
                });
            });
        }
        ed.addButton('copypaste', btnObj);
    };

    t.templateSelectItems = function(){
        var arr = [];
        t$.each(t.templates, function(key, mobj){
            if (!mobj) {
                return true;
            }
            var obj = {
                text: mobj.label || mobj.name || key,
                onclick: function(){
                    var content = '';
                    if (typeof mobj === 'String') {
                        content = mobj;
                    } else {
                        content = mobj.content;
                    }
                    content = content.toString() + "&nbsp;";
                    ed.insertContent(content);
                    t._updateCounts();
                }
            };
            arr.push(obj);
        });
        return arr;
    };

    if (t.templates) {
        ed.addButton('templateselect', {
            name: 'templateselect',
            type: 'menubutton',
            text: 'Templates',
            icon: false,
            menu: t.templateSelectItems()
        });
    }

    if (t.copyPasteContent) {
        t.getCopyPasteBtn();
    }

    if (t.badContent) {
        ed.addButton('badcontent', {
            name: 'badcontent',
            icon: 'fa fa-eraser',
            tooltip: 'Clear bad content',
            onclick: function(){
                t.editor.htmlEditor('clearBadContent');
            }
        });
    }

    if(t.upload_file){
        ed.addButton('ezdiaUpload', {
            name: 'ezdiaUpload',
            icon: 'fa fa-file-word-o',
            tooltip: 'Import content from word file',
            onclick: function(){
                t.editor.htmlEditor('uploadContent');
            }
        });
    }

    if (t.comments) {
        ed.addButton('addComment', {
            name: 'addComment',
            icon: 'fa fa-comments',
            tooltip: 'Add Comment',
            disabled: true,
            onclick: function(){
                t.editor.htmlEditor('comment', 'add');
                this.disabled(true);
            },
            onPostRender: function () {
                var self = this;
                ed.plugins.ezdia.addCommentButton = self;
                ed.plugins.ezdia.addCommentButton.disabled = self.disabled;

                ed.on('NodeChange', function () {
                    var tx = ed.selection.getContent();
                    if (tx && tx.trim()) {
                        self.disabled(false);
                    } else {
                        self.disabled(true);
                    }
                });
            }
        });

        ed.addButton('removeCommentAll', {
            name: 'removeCommentAll',
            icon: ' glyphicon glyphicon-erase',
            tooltip: 'Clear all comments',
            disabled: true,
            onclick: function(){
                t.editor.htmlEditor('comment', 'removeAll');
            },
            onPostRender: function () {
                var self = this;
                ed.plugins.ezdia.removeAllCommentsButton = self;
                ed.plugins.ezdia.removeAllCommentsButton.disabled = self.disabled;

                ed.on('NodeChange', function () {
                    var tx = ed.getContent();
                    if (hasCommentClsTag(tx)) {
                        self.disabled(false);
                    } else {
                        self.disabled(true);
                    }
                });
                var icon = '<span class="fa-stack fa-lg"><i class="fa fa-comments-o"></i><i class="fa fa-remove fa-stack-2x text-danger"></i></span>';
                this.$el.find('button').html(icon);
            }
        });

        ed.addButton('removeComment', {
            name: 'removeComment',
            icon: ' glyphicon glyphicon-erase',
            tooltip: 'Clear comments',
            disabled: true,
            onclick: function(){
                t.editor.htmlEditor('comment', 'remove');
            },
            onPostRender: function () {
                var self = this;
                ed.plugins.ezdia.removeCommentsButton = self;
                ed.plugins.ezdia.removeCommentsButton.disabled = self.disabled;

                ed.on('NodeChange', function (e) {
                    var tx = ed.selection.getContent();
                    if (isInsideCommentClsTag(e.element) || hasCommentClsTag(tx)) {
                        self.disabled(false);
                    } else {
                        self.disabled(true);
                    }
                });
                var icon = '<span class="fa-stack fa-lg"><i class="fa fa-comment-o"></i><i class="fa fa-remove fa-stack-2x text-danger"></i></span>';
                this.$el.find('button').html(icon);
            }
        });
    }

    if (!t.readonly && t.languagetool.enable) {
        ed.addButton('spellchecker', {
            name: 'spellchecker',
            icon: 'spellchecker',
            tooltip: 'Grammar Check',
            onclick: function(){
                t._languagetool();
            }
        });        
    }
    
    function isInsideCommentClsTag(n) {
        return !!ed.dom.getParent(n, t.commentClsSelect);
    }

    function hasCommentClsTag(tx) {
        var cls = $('<div>', {
            html: tx
        }).find(t.commentClsSelect).length;

        return (cls != 0) ? true : false;
    }

    function copy(from, to) {
        var elem = $("#" + to);
        var cur_val = elem.val();
        var fromElem = $('[name="'+ from +'"]');
        var pasteValue = fromElem.val() || fromElem.html() || '';

        if (!fromElem.length) {
            msgDialog('Field is not a part of this form.');
        } else if (!pasteValue) {
            msgDialog('Field is empty.');
        } else {
            elem.val(cur_val + pasteValue);
            var ed = tinyMCE.activeEditor;
            ed.selection.select(ed.getBody(), true);
            ed.selection.collapse(false);
            tinyMCE.get(to).fire('click');
        }

    }

    function msgDialog(msg) {
        $("#statusMsg").html(msg);
        $("#statusMsg").dialog({
            modal: true,
            title: 'Copy paste',
            width: 450,
            height: 200,
            buttons: {
                Ok: function () {
                    $(this).dialog("close");
                }
            }
        });
    }


});
